import request from '@/plugin/axios'
/**
 * 保存工作流
 * @param {*} data
 */
export function saveWorkFlow(data) {
  return request({
    url: '/approve/flowable/workFlow',
    method: 'post',
    data
  })
}
/**
 * 通过id删除工作流
 * @param {*} id
 */
export function deleteWorkFlow(id) {
  return request({
    url: '/approve/flowable/workFlow/' + id,
    method: 'delete'
  })
}
/**
 * 修改工作流
 * @param {*} data
 */
export function editWorkFlow(data) {
  return request({
    url: '/approve/flowable/workFlow',
    method: 'put',
    data: data
  })
}
/**
 * 通过表单类型ID获取流程
 * @param {*} data
 */
export function getWorkFlowByTableId(data, type) {
  return request({
    url: '/approve/flowable/workFlow/by/tableId/' + data + '/' + type,
    method: 'get'
  })
}
/**
 * 工作流分页
 * @param {*} params
 */
export function workFlowPage(data) {
  return request({
    url: '/approve/flowable/workFlow',
    method: 'get',
    params: data
  })
}
/**
 * 通过id获取单个工作流
 * @param {*} id 获取单个流程
 */
export function getOneWorkFlow(id) {
  return request({
    url: '/approve/flowable/workFlow/' + id,
    method: 'get'
  })
}
/**
 * 获取条件
 * @param {*} id 表单ID
 * @param {*} flowType 流程类别
 */
export function getConditions(id, flowType) {
  return request({
    url: '/approve/flowable/workFlow/condition/' + id + '/' + flowType,
    method: 'get'
  })
}
/**
 * 获取用户
 * @param {*} params
 */
export function getEmployees(data) {
  return request({
    url: '/approve/flowable/workFlow/user',
    method: 'get',
    params: data
  })
}
/**
 * 获取角色
 * @param {*} params
 */
export function getRoles(data) {
  return request({
    url: '/approve/flowable/workFlow/role',
    method: 'get',
    params: data
  })
}
/**
 * 获取部门
 * @param {*} params
 */
export function getDepartments(data) {
  return request({
    url: '/approve/flowable/workFlow/department',
    method: 'get',
    params: data
  })
}
/**
 * 开始流程
 * @param {*} data
 */
export function startWorkFlow(data) {
  return request({
    url: '/approve/flowable/start',
    method: 'post',
    data: data
  })
}
/**
 * 执行下个流程节点
 * @param {*} data
 */
export function doNextFlow(data) {
  return request({
    url: '/approve/flowable/doNext',
    method: 'put',
    data: data
  })
}
/**
 * 获取当前节点
 * @param {*} data
 */
export function getCurrentNodes(data) {
  return request({
    url: '/approve/flowable/current/nodes',
    method: 'post',
    data: data
  })
}
/**
 * 获取流程信息
 * @param {*} params
 */
export function getFlowNotice(data) {
  return request({
    url: '/approve/flowable/flow/notice',
    method: 'get',
    params: data
  })
}
/**
 * 阅读流程信息
 * @param {*} data
 */
export function readFlowNotice(data) {
  return request({
    url: '/approve/flowable/read/notice/' + data,
    method: 'put'
  })
}
/**
 * 获取下个节点
 * @param {*} data
 */
export function getNextChildNode(data) {
  return request({
    url: '/approve/flowable/next/childNode',
    method: 'post',
    data: data
  })
}
/**
 * 获取流程链条
 * @param {*} data
 */
export function getProcessChain(data) {
  return request({
    url: '/approve/flowable/childNode/process/chain',
    method: 'post',
    data: data
  })
}
/**
 * 审批签名保存
 * @param {*} params
 */
export function signature(data) {
  return request({
    url: '/approve/flowable/workFlow/signature',
    method: 'post',
    data: data
  })
}
/**
 * 获取抄送节点
 * @param {*} data
 */
export function getCCNode(data) {
  return request({
    url: '/approve/flowable/CC/node',
    method: 'post',
    data: data
  })
}
/**
 * 获取表单流程
 * @param {*} params
 */
export function getFormWorkFlow(data) {
  return request({
    url: '/approve/flowable/form/workFlow',
    method: 'get',
    params: data
  })
}

/**
 * 获取员工
 * @param {*} params
 */
export function getStaffs(data) {
  return request({
    url: '/approve/flowable/workFlow/staff',
    method: 'get',
    params: data
  })
}
